import React, { FC, useCallback, useState } from "react";
import { useAPI } from "kw/api/useAPI";
import { FileUploader } from "kanopi-components/FileUploader/FileUploader";
import { WidthContainer } from "kw/util/ChatFlow";

export const FileUploadInput: FC<TQuestionInput> = ({ value, onChange, ...props }) => {
  const { loading, fetchRequest } = useAPI();
  const [uploadedFile, setUploadedFile] = useState(value);
  const fileUploadHandler = useCallback(
    (files: File[]) => {
      // Always a single file for now. Might change in the future.
      if (files.length === 1) {
        const formData = new FormData();
        formData.append("File", files[0]);
        fetchRequest({
          url: "/documents/upload/",
          requestInit: {
            method: "POST",
            body: formData,
          },
          callback: (response) => {
            setUploadedFile(response);

            // Update value on parent Question component.
            onChange?.(response);
          },
        });
      }
    },
    [setUploadedFile, onChange]
  );
  const fileDeleteHandler = () => {
    // This might change once backend handles delete functionality
    setUploadedFile(null);
  };

  return (
    <WidthContainer>
      <FileUploader
        file={uploadedFile}
        onFileSelect={fileUploadHandler}
        multiple={false}
        uploading={loading}
        onFileDelete={fileDeleteHandler}
        {...props}
      />
    </WidthContainer>
  );
};
